import React from "react"
import PropTypes from "prop-types"
import "./UtilizationView.scss"
import Footer from "../../components/Footer"
import WelcomeBannerControlled from "../../components/WelcomeBanner/WelcomeBannerControlled"
import CalendarDropdownWithStore from "../../components/Calendar"
import UtilizationSummaryTableControlledWithData from "../../components/UtilizationSummaryTable/UtilizationSummaryTableControlledWithData"

const UtilizationView = props => {
  return (
    <div className="UtilizationView">
      <div className="subheader">
        <h1>
          Utilization
          <span className="badge badge-secondary">beta</span>
        </h1>
        <CalendarDropdownWithStore />
      </div>
      <WelcomeBannerControlled reset={process.env.NODE_ENV === "development"} />
      <UtilizationSummaryTableControlledWithData />
      <Footer />
    </div>
  )
}

UtilizationView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      facilityId: PropTypes.string,
    }),
  }),
}

export default UtilizationView
